var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 2H11.5V0.5H10V2H4V0.5H2.5V2H1.75C0.925 2 0.25 2.675 0.25 3.5V14C0.25 14.825 0.925 15.5 1.75 15.5H12.25C13.075 15.5 13.75 14.825 13.75 14V3.5C13.75 2.675 13.075 2 12.25 2ZM12.25 14H1.75V6.5H12.25V14ZM1.75 5V3.5H12.25V5H1.75ZM5.92 12.845L10.3675 8.3975L9.5725 7.6025L5.92 11.255L4.3375 9.6725L3.5425 10.4675L5.92 12.845Z",
    fill: "#182E45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderChecked);
export default __webpack_public_path__ + "static/media/calenderChecked.92ae51190e84c2fd032f5c30da8bd85a.svg";
export { ForwardRef as ReactComponent };